module.exports = require('constants')



//////////////////
// WEBPACK FOOTER
// ./node_modules/fs-constants/browser.js
// module id = tTBl
// module chunks = 0